import { render, staticRenderFns } from "./EmbeddedHooYu.vue?vue&type=template&id=3548ab3d&scoped=true&"
import script from "./EmbeddedHooYu.vue?vue&type=script&lang=js&"
export * from "./EmbeddedHooYu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3548ab3d",
  null
  
)

export default component.exports